import { flattenDeep, isString, isArray } from 'lodash-es';

export function classes(...classes: Array<any>): string {
  return classes.map(c => isArray(c) ? flattenDeep(c) : c).filter(isString).join(' ');
}
